import React, { useRef, useEffect } from 'react';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { Header } from '../../Components/Layout/Header.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';

export default function BonusesCasinoSuperKisa(props) {

    const [height, setHeight] = React.useState("0px");
    const iframeRef = useRef(null);

    const getMessage = (message) => {
        if (message.data.event == "resize") {
            setHeight((message.data.params.height) + "px");
        }
    } 

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('message', getMessage);

        if (iframeRef.current?.contentWindow) {
            setTimeout(() => {
                iframeRef.current.contentWindow.postMessage({ type: "darkMode", value: casino.utils.getCasinoTheme() === "dark"}, "*");
            }, 1000);
        }

        return () => window.removeEventListener('message', getMessage);
    }, []);


    return (<>
            <MetaTags title="Promocije - SuperSport CASINO" description="Superskok Utrka u SuperSport CASINU!" />
            <Header key="header" {...props}></Header>
            <div className='superkisa-container'>
                <iframe src={`${casino.config.casinoModulesUrl}super-kisa/`} scrolling="no" height={height}  ref={iframeRef}></iframe>
            </div>
            <ObavijestiCasino {...props}></ObavijestiCasino>
        </>
    )
}